export default {
    meta: {
        title: '工作台',
        url: '/workbench',
        urlName: '工作台',
    }
};
